import { testimonials } from '@/mocks/home';

export default function Testimonials() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            用户好评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来自千万用户对茄子视频影视平台推荐的真实使用反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                &ldquo;{t.comment}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <span className="text-sm font-semibold text-foreground-950">{t.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}